<template>
  <div class="main px-3 py-2">
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <b-row>
      <b-col sm="0" md="2"></b-col>
      <b-col sm="12" md="8">
        <div class="row title mx-0">
      <img class="sim-thumbnail" :src="thumbnail" @error="altImg" width="100px" height="100px"/>
      <div class="col d-flex align-items-center">
        <h2>{{app.name}}</h2>
    </div>
    </div>
    <div class="mt-4">Enter your {{ isEnablePIN ? 'PIN' : 'email'}} to get download Link</div>
    <b-alert variant="success" :show="alertMessage ? true: false" dismissible> {{alertMessage}} </b-alert>
    <b-alert variant="danger" :show="errorMessage ? true: false" dismissible> {{errorMessage}} </b-alert>

    <!-- Send Email Form -->
    <div v-if="!isEnablePIN">
      <div class="input-group mt-4">
        <input type="text" v-model="textEmail" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
        <div class="input-group-append">
          <span class="input-group-text" id="basic-addon2">@dtgo.com</span>
        </div>
      </div>
      <div class="mt-1">
        <button  class="btn btn-primary w-100" @click="sendEmail">{{labelGetDownloadLink}}</button>
      </div>
    </div>

    <!-- Download By Pin Form -->
    <div v-else>
      <div class="input-group mt-4">
        <input type="text" v-model="pin" class="form-control" placeholder="Enter pin for download" aria-label="Recipient's username" aria-describedby="basic-addon2">
      </div>
      <div class="mt-1">
        <button  class="btn btn-primary w-100" @click="download">Download</button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <h3>{{version.version}}</h3>
        <div><small>{{releaseago}}</small></div>
        <h4 style="margin-top: 30px">Release Note</h4>
        <div class="appSummary">{{version.noteNew}}</div>
      </div>
    </div>
      </b-col>
      <b-col sm="0" md="2"></b-col>
    </b-row>
  </div>
</template>

<script>
import { dateToStringWithTimeFull } from '../../../src/assets/utils/time';
import Loading from '../../components/Loading';
import axios from 'axios';

export default {
  data () {
    return {
      alertMessage: null,
      thumbnail: '',
      platform: '',
      app: {},
      textEmail: '',
      version: {},
      isLoading: false,
      pin: '',
      pvalue: 0,
      images: [],
      showCarousel: false,
      releaseago: null,
      altImage: null,
      information: {
        provider: 'DTGO Coporation Limited.',
        size: '',
        category: 'Lifestyle',
        compatibility: '',
        compatibility_short: '',
        language: '',
        ageRating: '',
        copyright: '2018 Magnolia Quality Development',
        developerWebSite: '',
        privacyPolicy: ''
      },
      downloadMessage: 'Please download this app on your mobile phone or on your ',
      iOS: 'iPad',
      android: 'tablet',
      userEmail: null,
      errorMessage: '',
      labelGetDownloadLink: 'Get Download Link',
      isEnablePIN: true
    };
  },
  methods: {
    getData () {
      this.isLoading = true;
      let appId = this.$route.params.appid;
      let versionId = this.$route.params.versionid;
      const apiBaseUrl = process.env.VUE_APP_URL_UNIVERSAL_API;
      let getUrl = apiBaseUrl + `/app-store/static-landing-page/${appId}`;
      if (versionId) {
        getUrl = apiBaseUrl + `/app-store/landing-page/${appId}/${versionId}`;
      }
      this.axios.get(getUrl, {
        headers: {
          Accept: 'application/json'
        }
      }).then(response => {
        const data = response.data.data;
        if (data) {
          this.app = data.app;
          this.version = data.version;
          this.releaseago = dateToStringWithTimeFull(new Date(this.version.createdAt));
          this.information.compatibility = this.version.compatibility;
          this.platform = data.app.platform;
          this.isEnablePIN = data.app.isEnablePIN;
          let defaultThumbnail = '';
          this.information.compatibility_short = 'See compatibility information:';
          if ('ios' === this.platform) {
            defaultThumbnail = '/images/app-store/thumbnail_ios.png';
            this.downloadMessage += this.iOS;
          } else {
            defaultThumbnail = '/images/app-store/thumbnail_android.png';
            this.downloadMessage += this.android;
          }
          this.thumbnail = data.version.thumbnail || defaultThumbnail;
          this.altImage = defaultThumbnail;
          this.setCarouselImages(this.version.screenshots);
        }
      }).catch(error => {
        // handle later
        console.log(error);
      }).finally(this.isLoading = false);
    },
    sendEmail () {
      if (this.textEmail) {
        this.errorMessage = '';
        this.alertMessage = '';
        this.isLoading = true;
        const form = {
          email: this.textEmail + '@dtgo.com',
          appId: this.app.id,
          versionId: this.version.id
        };
        this.labelGetDownloadLink = 'Sending Email....';
        axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/send-email', form)
          .then(response => {
            console.log(response);
            this.alertMessage = 'send email succesfully.';
            this.labelGetDownloadLink = 'Get Download Link';
          })
          .catch(error => console.log(error))
          .finally(this.isLoading = false);
      } else {
        this.errorMessage = 'Please enter your email.';
        this.alertMessage = '';
      }
    },
    setCarouselImages (screenshots) {
      this.images = [];
      for (let i = 0; i < screenshots.length; i++) {
        let screenshot = screenshots[i];
        this.images.push({
          id: screenshot.id,
          big: screenshot.url,
          thumb: screenshot.url
        });
      }
      this.showCarousel = screenshots.length > 0;
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    getDownloadLink () {
      if (this.userEmail) {
        let appId = this.$route.params.appid;
        let versionId = this.$route.params.versionid;
        const bodyData = { 'email': this.userEmail + '@dtgo.com', 'appId': appId, 'versionId': versionId };
        this.isLoading = true;
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/send-email', bodyData)
          .then(response => {
            // console.log
            this.isEditing = false;
            // const data = response.data.data;
            // console.log(response);
            // this.$router.push({ name: 'apps-details-2', params: { id: app.id } });
            this.errorMessage = '';
            this.alertMessage = 'Email has been sent';
          })
          .catch(error => { this.errorMessage = error.response && error.response.data && error.response.data.data ? error.response.data.data : error.message; })
          .finally(() => { this.isLoading = false; });
      } else {
        this.errorMessage = 'Please enter your email.';
        this.alertMessage = '';
      }
    },
    download () {
      /**
       * Read me: /app-store/download-app/ -> use token and api-key
       *          /app-store/download/ -> use PIN
       */

      let url = process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/download/${this.version.id}/${this.pin}`;
      if ('ios' === this.platform) {
        window.location.replace(`itms-services://?action=download-manifest&url=${url}`);
      } else {
        window.location.replace(url);
      }
    }
  },
  computed: {
    releaseDate () {
      return dateToStringWithTimeFull(new Date(this.version.createdAt));
    }
  },
  mounted () {
    document.title = 'Admin Console: Download App';
    this.alertMessage = '';
    this.errorMessage = '';
    this.getData();
  },
  components: {
    'app-loading': Loading
  }
};
</script>
<style src="@/assets/css/appstore-landing2.css"></style>
